import { connect } from 'react-redux'
import { selectors as settingsSelectors } from '../../features/Settings'
import { selectors as backendSelectors } from '../../features/Backend'
import { selectors as syncSelectors } from '../../features/Sync'
import MainSection from '../../components/MainSection'
import localize from '../../store/localize'
import strings from '../../components/MainSection/main-section.json'

function mapStateToProps(state) {
    const locale = backendSelectors.getLocale(state)
    return {
        locale,
        layout: settingsSelectors.getLayout(state),
        background: syncSelectors.getBackgroundUrl(state),
        newsHeader: localize(strings, locale, 'news'),
    }
}

export default connect(mapStateToProps)(MainSection)



// WEBPACK FOOTER //
// ./src/containers/MainSection/main-section.js